<template>
  <div>
    <ContentSectionLoader v-if="!loaded" />
    <Transition name="fade">
      <div v-if="loaded">
        <div
          v-if="loaded && posts.length"
          class="px-2 mt-4 text-right hidden sm:block"
        >
          <a
            v-if="categories.length"
            v-can="'archive-discussions'"
            :href="archivedUrl"
            class="btn btn--border btn--sm mr-4"
            v-text="'Archived'"
          />
          <a
            v-can="'create-discussions'"
            :href="createDiscussionUrl"
            class="btn btn--border btn--sm"
            v-text="'Create New Discussion'"
          />
        </div>
        <div
          v-if="loaded && posts.length"
          class="flex flex-col md:flex-row items-center content-center px-2 mt-4"
        >
          <h2 class="flex-1 m-0 mb-2">
            {{ title }}
            <span
              v-if="loaded"
              v-text="`(${count})`"
            />
          </h2>
          <div
            v-if="loaded && posts.length"
            class="px-2 mb-4 text-center sm:hidden"
          >
            <a
              v-can="'create-discussions'"
              :href="createDiscussionUrl"
              class="btn btn--border btn--sm"
              v-text="'Create New Discussion'"
            />
          </div>
          <div class="w-3/4 sm:w-1/2 text-center sm:text-right text-xs">
            Sort By:
            <select
              v-model="sort_by"
              class="w-16 sm:w-24 mb-0 ml-2 text-xs"
            >
              <option
                value="updated_at"
                v-text="'Latest'"
              />
              <option
                value="title"
                v-text="'Title'"
              />
              <option
                value="status"
                v-text="'Status'"
              />
              <option
                value="replies_count"
                v-text="'Replies'"
              />
            </select>
            <select
              v-model="sort_direction"
              class="w-20 sm:w-24 mb-0 text-xs"
            >
              <option
                value="asc"
                v-text="'Ascending'"
              />
              <option
                value="desc"
                v-text="'Descending'"
              />
            </select>
          </div>
        </div>
        <div
          v-if="count"
          class="pl-2"
        >
          <div class="table-responsive">
            <table
              class="table table-files min-w-table"
              style="min-height: auto;"
            >
              <thead>
                <tr>
                  <th v-text="'Discussion'" />
                  <th v-text="'Category'" />
                  <th
                    v-can="'manage-discussions'"
                    v-text="'Status'"
                  />
                  <th>
                    <span
                      class="block text-center"
                      v-text="'Replies'"
                    />
                  </th>
                </tr>
              </thead>
              <tbody>
                <DiscussionListItem
                  v-for="post in posts"
                  :key="post.uuid"
                  :post="post"
                />
              </tbody>
            </table>
            <Pagination
              v-if="showPagination"
              :pagination="pagination"
              :on-change="onPageChange"
            />
          </div>
        </div>
        <div
          v-if="loaded && posts.length && categoryUuid"
          class="empty my-4 mx-2"
        >
          <section>
            <h2 v-text="`Let's talk!`" />
            <p>Discussions allow you to communicate with members.</p>
            <a
              v-can="'create-discussions'"
              :href="createDiscussionUrl"
              class="btn btn--border"
              v-text="'Start a discussion'"
            />
          </section>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script type="text/babel">
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DiscussionList',
  props: {
    title: {
      type: String,
      required: false,
      default: 'Latest Discussions',
    },
    categoryUuid: {
      type: String,
      required: false,
      default: '',
    },
    showPagination: {
      type: Boolean,
      required: false,
      default: true,
    },
    page: {
      type: Number,
      required: false,
      default: 1,
    },
    perPage: {
      type: Number,
      required: false,
      default: 20,
    },
  },
  data() {
    return {
      loaded: false,
      sort_by: 'updated_at',
      sort_direction: 'desc',
    }
  },
  computed: {
    ...mapState({
      count: state => state.discussion.posts.data.length,
      pagination: state => state.discussion.posts.meta.pagination,
      totalCount: state => _.get(state.discussion.posts, 'meta.pagination.total', 0),
      posts: state => state.discussion.posts.data,
      categories: state => state.discussion.categories.data,
    }),
    createDiscussionUrl() {
      return this.categoryUuid
        ? `${this.$urlGenerator.active('discussions/create')}?category=${this.categoryUuid}`
        : this.$urlGenerator.active('discussions/create')
    },
    params() {
      return _.extend({
        include: 'lastReply,category',
        per_page: this.perPage,
        page: this.page,
        sort_by: this.sort_by,
        sort_direction: this.sort_direction,
      }, !this.categoryUuid ? {} : {
        category_uuid: this.categoryUuid,
      })
    },
    archivedUrl() {
      return this.$urlGenerator.active('discussions/archived#posts')
    },
  },
  watch: {
    sort_by() {
      this.fetch(true)
    },
    sort_direction() {
      this.fetch(true)
    },
  },
  beforeMount() {
    this.discussionGetCategories({})
  },
  mounted() {
    this.fetch()
  },
  methods: {
    ...mapActions([
      'discussionGetPosts',
      'discussionGetCategories',
    ]),
    onPageChange(page) {
      this.page = page

      this.fetch()
    },
    fetch(shouldForce = false) {
      this.discussionGetPosts({
        params: this.params,
        force: shouldForce,
      }).then(() => {
        this.loaded = true

        this.$emit('loaded')
      })
    },
  },
}
</script>
